import { ChatSessionShareDialogContent } from './ChatSessionShareDialogContent';
import './ChatSessionShareDialog.css';

type ChatSessionShareDialogProps = {
  isOpen: boolean;
  sessionId: string | null;
  isShareMode: boolean;
  sessionTitle: string;
  onLeave: (sessionId: string, sessionTitle: string) => void;
  onClose: () => void;
};

export function ChatSessionShareDialog({
  isOpen,
  sessionId,
  isShareMode,
  sessionTitle,
  onLeave,
  onClose,
}: ChatSessionShareDialogProps) {
  if (!isOpen || sessionId === null) {
    return null;
  }

  return (
    <ChatSessionShareDialogContent
      key={sessionId}
      sessionId={sessionId}
      isShareMode={isShareMode}
      sessionTitle={sessionTitle}
      onLeave={onLeave}
      onClose={onClose}
    />
  );
}
